module.exports = __webpack_public_path__ + "img/usa.4e842b6.svg";